import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight, Stars } from 'react-bootstrap-icons';
import LandingHeader from '../components/LandingHeader';
import LandingFooter from '../components/LandingFooter';
import useScrollToTop from '../hooks/useScrollToTop';
import aboutUsImage from '../assets/about/aboutus.png';
import './AboutUs.css';

const AboutUs: React.FC = () => {
  const navigate = useNavigate();
  useScrollToTop();

  const handleTryNow = () => {
    navigate('/register');
  };

  return (
    <div className="about-page landing-page">
      <LandingHeader />

      <div className="page-header">
        <h1 className="page-title">Where Momentum Begins</h1>
      </div>

      <section className="work-section">
        <Container>
          <div className="work-content">
            <div className="work-text">
              <h2>The Work Is The Way</h2>
              <p>
                At Revealer AI, we believe design isn't just about the final result; it's about the <strong>becoming</strong>. We exist for that specific, often paralyzing moment between gathering data and designing a concept, that early haze where you're staring at a blank screen, buried in transcripts, and unsure where to begin.
              </p>
              <p>
                <strong>We call this "Blank Screen Syndrome," and we've made it our mission to fight it.</strong>
              </p>
            </div>
            <div className="work-image">
              <img src={aboutUsImage} alt="Revealer AI workflow" />
            </div>
          </div>
        </Container>
      </section>

      <section className="built-section">
        <Container>
          <div className="built-content">
            <h2>Built by Designers, for the Ones in Motion</h2>
            <p>
              Revealer AI was founded by product designers who knew this pain intimately. After years of leading teams and running into the same invisible wall ("the discovery bottleneck") we built the tool we always wished existed.
            </p>
            <p>
              We understand that discovery is messy, and the pressure to show progress before clarity has formed can feel overwhelming. Revealer AI is designed to bridge that gap, turning the messiness of UX discovery into the momentum to move forward.
            </p>
          </div>
        </Container>
      </section>

      <Container>
        <section className="mission-vision-section">
          <div className="mission-vision-cards">
            <div className="mission-card">
              <h3>Our Mission</h3>
              <p>
                To empower product teams to turn research chaos into clarity, enabling them to move faster, think smarter, and design what's next with confidence.
              </p>
            </div>
            <div className="vision-card">
              <h3>Our Vision</h3>
              <p>
                To create a world where product teams turn chaos into clarity and unlock the momentum to build what's next.
              </p>
            </div>
          </div>
        </section>

        <section className="cocreator-section">
          <div className="cocreator-card">
            <div className="card-header">
              <Stars />
              <h3>Your Co-Creator, Not Your Replacement</h3>
            </div>
            <p>
              We believe the best work isn't done for you; it's done with you. Revealer AI is a co-creative ecosystem. The intelligence beneath your intuition and the wireframe under your "what-if."
            </p>
            <p>
              We don't automate creativity; we ignite it. By transforming your raw research into insight-driven artifacts like wireframes, personas, and flows, we help you start with clarity and design with confidence.
            </p>
          </div>
        </section>
      </Container>

      <section className="cta-section">
        <Container>
          <h2>Join The Ones In Motion.</h2>
          <p>Get started with your first project.</p>
          <Button variant="primary" onClick={handleTryNow}>
            TRY REVEALER NOW <ArrowUpRight className="ms-2" />
          </Button>
        </Container>
      </section>

      <LandingFooter />
    </div>
  );
};

export default AboutUs;
